import TrainingPage from './TrainingPage';

export default TrainingPage; 